import differenceBy from "lodash/differenceBy";
import { SkillsFramework } from "PFCore/types";

export const getUnselectedSkillsFrameworksSuggestions = (
  suggestions: SkillsFramework[],
  excludedFrameworks: (SkillsFramework | undefined)[]
): SkillsFramework[] => differenceBy(suggestions, excludedFrameworks, "id");
